module.exports = __webpack_public_path__ + "static/media/throphy2.aa4f3e76.png";